import React, { FC } from 'react';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { setApplicationViewData } from '../../store/merchnts/actions/application-view';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { useNavigate } from 'react-router-dom';
import { APPLICATION_VIEW_BASE_VIEW, APPLICATION_VIEW_STEPS } from './ApplicationViewAsideMenu';
import { successAlert } from '../ToastMessage';
import { IOwners } from '../../interfaces/merchant';
import { scrollToError } from '../../utils/formikUtils';
import { checkIsFileValid } from '../application/DocumentsUploader';

interface Props {
  formik: any;
  checkBoxes: string[];
  fileList: any[];
  owners: IOwners[];
  uploadedDocuments: any[];
  setIsSubmitted: (isSubmitted: boolean) => void;
}
export const ApplicationViewBusinessDetailsFooter: FC<Props> = (props) => {
  const { formik, checkBoxes, fileList, owners, uploadedDocuments, setIsSubmitted } = props;
  const navigate = useNavigate();

  const { merchantState: { applicationViewData, isSavingApplicationViewDataLoading }, dispatch } = useMerchants();
  const [isNext, setIsNext] = React.useState<boolean>(false);

  const handleNext = (): void => {
    navigate(`/${APPLICATION_VIEW_BASE_VIEW}/${APPLICATION_VIEW_STEPS.SUMMARY}`);
  };

  const handleSave = (): void => {
    successAlert({
      title: 'Application information was saved!'
    });
  };

  const handleSubmit = async (isNext: boolean, handleSuccess: () => void): Promise<void> => {

    setIsNext(isNext);

    if (isNext) {
      formik.handleSubmit();
      const errors = await formik.validateForm();
      if (Object.keys(errors).length !== 0) {
        scrollToError(errors, 'ApplicationViewBusinessDetailsFooter');
        return;
      }

      // if (!fileList?.length && !uploadedDocuments?.length) {
      //   // setIsSubmitted(true);
      //   scrollToError({
      //     documents: { 0: 'add document' }
      //   });
      //   return;
      // }
    }

    // if (!checkIsFileValid(fileList)) return;

    await setApplicationViewData({
      dispatch,
      formik,
      mid: applicationViewData?.id,
      // acquisition: checkBoxes,
      fileList,
      owners,
      isNext,
      handleSuccess,
      uploadedFiles: uploadedDocuments,
      alreadyUploadedDocuments: applicationViewData?.uploadedDocuments,
    });
    setIsNext(false);
  };

  return(
    <div className="d-flex align-items-center mt-10 justify-content-end">
      <ButtonComponent
        buttonName="Save"
        buttonType={BUTTON_TYPE.WHITE}
        onButtonClick={(): Promise<void> => handleSubmit(false, handleSave)}
        additionalClass="me-5 w-75px"
        isDisabled={isSavingApplicationViewDataLoading}
        loading={!isNext && isSavingApplicationViewDataLoading}
      />

      <ButtonComponent
        additionalClass="btn-sm w-100px"
        onButtonClick={(): Promise<void> => handleSubmit(true, handleNext)}
        isDisabled={isSavingApplicationViewDataLoading}
        loading={isNext && isSavingApplicationViewDataLoading}
      >
        <>
          <span className="me-2">Next</span>
          <FontAwesomeIcon icon={faAngleRight} width={12} />
        </>

      </ButtonComponent>
    </div>

  );
};
